const TopScorersTypes = {
    GET_TOP_SCORERS_START:'GET_TOP_SCORERS_START',
    GET_TOP_SCORERS_SUCCESS:'GET_TOP_SCORERS_SUCCESS',
    GET_TOP_SCORERS_FAILED:'GET_TOP_SCORERS_FAILED',

}

export default TopScorersTypes